import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

// Pages
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import MainSite from "./HelpThemShineTrust";
import PrivateRoute from "./components/PrivateRoute";

export default function App() {
  const { currentUser } = useAuth();

  return (
    <Routes>
      {/* ── Public NGO Website ── */}
      <Route path="/" element={<MainSite />} />

      {/* ── Auth Pages ── */}
      <Route path="/login" element={
        currentUser ? <Navigate to="/dashboard" replace /> : <Login />
      }/>
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* ── Protected Dashboard ── */}
      <Route path="/dashboard" element={
        <PrivateRoute><Dashboard /></PrivateRoute>
      }/>

      {/* ── Admin Panel ── */}
      <Route path="/admin/*" element={
        <PrivateRoute adminOnly={true}><Dashboard /></PrivateRoute>
      }/>

      {/* ── Catch all ── */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
